module.exports = __webpack_public_path__ + "img/Icon-card-region.4f4f567c.svg";